import React, { useContext } from "react";
import moment from "moment";

import { IntlContext } from "context";
import type { NoteInterface } from "types/note";
import type { OurServiceInterface } from "types/service";
import { MutedInset } from "components/ui/muted-inset";
import StarRating from "components/ui/star-rating";
import { ProviderDetailCard } from "./ProviderDetailCard";

interface Props {
    provider: OurServiceInterface["provider"];
    notes: NoteInterface[] | null;
}

export const ProviderReviewsCard: React.FC<Props> = ({ provider, notes }) => {
    const intl = useContext(IntlContext);
    const rating = provider.rating;

    const title = rating?.count
        ? intl.formatMessage("provider.view.section_reviews_count", { count: rating.count })
        : intl.formatMessage("provider.view.section_reviews");

    return (
        <ProviderDetailCard title={title} titleSize="xl">
            {notes && notes.length > 0 ? (
                <div className="space-y-3">
                    {notes.map((feedback) => (
                        <MutedInset key={feedback.id} padding="md">
                            <div className="mb-2 flex items-start justify-between">
                                <div>
                                    <p className="text-sm font-semibold text-foreground">{feedback.first_name}</p>
                                    <p className="text-xs text-muted-foreground">
                                        {moment(feedback.created_at).format("DD MMM YYYY")}
                                    </p>
                                </div>
                                <StarRating value={feedback.note} className="shrink-0" starClassName="h-4 w-4" />
                            </div>
                            <p className="text-sm leading-relaxed text-muted-foreground">{feedback.comment}</p>
                        </MutedInset>
                    ))}
                </div>
            ) : (
                <p className="text-sm text-muted-foreground">{intl.formatMessage("provider.view.no_reviews")}</p>
            )}
        </ProviderDetailCard>
    );
};
